export default __webpack_public_path__ + "static/media/magnet-agency.e82111ba.svg";